export default __webpack_public_path__ + "static/media/3BHKKeyplan.c9c8c47a.webp";